import { ArrowLeftOutlined } from "@ant-design/icons";
import { Button, Tabs } from "antd";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../app/hooks";
import { PageHeader } from "../components/PageHeader";
import { getOrganization } from "../features/organizationAdminsSlice";
import { RouteNames } from "../routes";
import { CaretakersPage } from "./CaretakersPage";
import { DoctorsPage } from "./DoctorsPage";
import { OrganizationAdminsPage } from "./OrganizationAdminsPage";
import { PatientsPage } from "./PatientsPage";

export const OrganizationPage = () => {
    const params = useParams();
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const organization = useAppSelector(state => state.organizationAdmins.organization);
    const [activeTabKey, setActiveTabKey] = useState<string>("1");
    const { t } = useTranslation();

    useEffect(() => {
        if (params.organizationId !== undefined) {
            dispatch(getOrganization(params.organizationId));
        }
    }, []);

    return (
        <>
            <PageHeader
                eyebrow={t("menu.organizations")}
                title={organization?.name ?? t("page.organization.title")}
                actions={
                    <Button
                        icon={<ArrowLeftOutlined />}
                        onClick={() => navigate(`/${RouteNames.organizations}`)}
                    >
                        {t("actions.back")}
                    </Button>
                }
            />
            <Tabs
                defaultActiveKey={activeTabKey}
                type="line"
                onChange={key => setActiveTabKey(key)}
            >
                <Tabs.TabPane tab={t("page.organization.tab.administrators")} key="1">
                    <OrganizationAdminsPage organizationId={params.organizationId!} />
                </Tabs.TabPane>
                <Tabs.TabPane tab={t("page.organization.tab.patients")} key="2">
                    <PatientsPage organizationId={params.organizationId!} />
                </Tabs.TabPane>
                <Tabs.TabPane tab={t("page.organization.tab.caretakers")} key="3">
                    <CaretakersPage organizationId={params.organizationId!} />
                </Tabs.TabPane>
                <Tabs.TabPane tab={t("page.organization.tab.doctors")} key="4">
                    <DoctorsPage organizationId={params.organizationId!} />
                </Tabs.TabPane>
            </Tabs>
        </>
    );
}
